import script from "./VoucherTransactionsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherTransactionsList.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherTransactionsList.vue?vue&type=style&index=0&id=072a8012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072a8012"]])

export default __exports__